import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CustomizeApiFileUploaderService } from '../customize-api-file-uploader.service';
import { CustomizeApiService } from '../customize-api.service';

@Component({
  selector: 'app-customize-image-upload',
  templateUrl: './customize-image-upload.component.html',
  styleUrls: ['./customize-image-upload.component.scss'],
  // Provide a copy of this service to each component that gets instantiated.
  // This way it can set upload params per component.
  providers: [CustomizeApiFileUploaderService],
})
export class CustomizeImageUploadComponent implements OnInit {
  uploadUrl$: Observable<string>;

  @Input()
  currentImageUrl: string;
  @Input()
  partnerId: string;
  @Input()
  category: string;

  imageUrl = new UntypedFormControl('');

  constructor(
    private customizeApi: CustomizeApiService,
    public customizeFileUploader: CustomizeApiFileUploaderService,
    private snackbarService: SnackbarService,
    private translateService: TranslateService,
  ) {}

  ngOnInit(): void {
    this.uploadUrl$ = this.customizeApi
      .getUploadUrl()
      .pipe(tap((url) => this.customizeFileUploader.setUploadParams(url, this.partnerId, this.category)));
    if (this.currentImageUrl) {
      this.imageUrl.patchValue(this.currentImageUrl);
    }
    this.imageUrl.valueChanges.subscribe(console.log);
  }

  deleteImage(): void {
    // If blob is deleted, clear the input so they can upload a new image.
    this.customizeApi.deleteResource(this.partnerId, this.category).subscribe(
      () => {
        this.imageUrl.patchValue('');
        this.snackbarService.successSnack(
          this.translateService.instant('CUSTOMIZE_PARTNER.FILE_UPLOADS.SUBMIT_MESSAGES.DELETE_SUCCESS'),
        );
      },
      (err) => {
        console.error(err);
        this.snackbarService.errorSnack(
          this.translateService.instant('CUSTOMIZE_PARTNER.FILE_UPLOADS.SUBMIT_MESSAGES.DELETE_FAILURE'),
        );
      },
    );
  }
}
